import { render, staticRenderFns } from "./date.vue?vue&type=template&id=fc56fb10&scoped=true"
import script from "./date.vue?vue&type=script&lang=js"
export * from "./date.vue?vue&type=script&lang=js"
import style0 from "./date.vue?vue&type=style&index=0&id=fc56fb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc56fb10",
  null
  
)

export default component.exports